module.exports = __webpack_public_path__ + "static/img/footlogo.1d3cc65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footlogo.png
// module id = pzb+
// module chunks = 68